/**
 * @ngdoc component
 * @name wishlist.component:saveForLater
 * @description
 * Component description
 */
(function() {
    'use strict';

    var saveForLater = {
        bindings: {
            buylater: '<',
            onAction: '&'
        },
        controller: saveForLaterCtrl,
        templateUrl: 'save-for-later.component.html'
    };

    angular.module('itxApp.wishlist')
        .component('saveForLater', saveForLater);

    saveForLaterCtrl.$inject = [
        'SaveForLaterService',
        'ItxUtilsFct',
        'ItxTranslateSvc',
        'ItxLoaderFct'
    ];

    function saveForLaterCtrl(
        SaveForLaterService,
        ItxUtilsFct,
        ItxTranslateSvc,
        ItxLoaderFct
    ) {

        var _this = this;
        _this.showBuylater = false;

        _this.$onInit = function() {
            _this.formatPrice = inditex.formatPrice.bind(inditex);
            _this.typeItem = {
                name: 'buylater',
                actions: [
                    {
                        name: 'add:shopcart',
                        text: ItxTranslateSvc.translateCms('legacy.common.addToCart')
                    },
                    {
                        name: 'delete:buylater',
                        text: ItxTranslateSvc.translateCms('legacy.common.delete')
                    }
                ]
            };
        };

        _this.deleteItem = function(item) {
            SaveForLaterService.deleteItemList(item)
            .then(function(buylater) {
                _this.buylater = buylater;
            });
        };
        
        _this.addToShopcart = function(item) {
            ItxLoaderFct.show();
            SaveForLaterService.addItemShopcart(item)
            .then(function(buylater) {
                _this.buylater = buylater;
                ItxLoaderFct.hide();
            });
        };
        
        _this.getImage = function(item, type) {
            var images;
            switch (type) {
                case 'colorcut':
                    images = ItxUtilsFct.getImageProductUrls(item, item.color.id, 'colorcut', 'color', 'color');
                    break;
                default:
                    images = ItxUtilsFct.getImageProductUrls(item, item.color.id, 'checkout', 'main', 'shopCart');
                    break;
            }
            return images[0];
        };

        _this.getSizeName = function (sizeName) {
            if (sizeName === '01') {
                return ItxTranslateSvc.translateCms('legacy.one_size');
            } else {
                return sizeName;
            }
        };

        // _this.deleteList = function () {
        //     ItxLoaderFct.show();
        //     SaveForLaterService.deleteArrayItemsList()
        //     .then(function(buylater) {
        //         _this.buylater = buylater;
        //         ItxLoaderFct.hide();
        //     });
        // };
    }

})();